import React, { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import { useSelector } from 'react-redux';

const OfflineBanner = () => {
  const isOnline = useSelector((state) => state.pwa.isOnline);
  const [open, setOpen] = useState(false);
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    if (!isOnline) {
      setOpen(true);

      if (isMobile) {
        const timer = setTimeout(() => setOpen(false), 4000);
        return () => clearTimeout(timer);
      }
    } else {
      setOpen(false);
    }
  }, [isOnline, isMobile]);

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ bottom: { xs: 70, sm: 24 } }}
    >
      <Alert
        severity="warning"
        icon={<WifiOffIcon />}
        sx={{
          width: '100%',
          backgroundColor: '#ff9800',
          color: '#fff',
          '& .MuiAlert-icon': { color: '#fff' },
        }}
      >
        You're offline. Some features may not be available.
      </Alert>
    </Snackbar>
  );
};

export default OfflineBanner;